"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    root: {
      display: 'inline-block'
    },
    secondaryTitle: {
      color: '#343434',
      lineHeight: '19px',
      textTransform: 'capitalize',
      margin: '0 0 20px 0'
    },
    flagValue: function flagValue(props) {
      return {
        background: '#F0F0F0 0% 0% no-repeat padding-box',
        borderRadius: '4px',
        padding: '8px 16px',
        margin: 'auto',
        display: 'inline-block',
        font: 'normal normal 600 11px/15px',
        letterSpacing: '1.65px',
        color: '#626262',
        textTransform: 'uppercase',
        "float": props.alignRight ? 'right' : 'left'
      };
    },
    value: function value(props) {
      if (props.secondary) {
        return {
          fontSize: '16px',
          fontWeight: typography.fontWeightBold,
          margin: 0
        };
      }
      return {
        fontSize: '22px',
        fontWeight: typography.fontWeightLight,
        margin: 0,
        textAlign: props.alignRight ? 'right' : 'left'
      };
    }
  };
}, {
  name: 'Stat'
});
exports.useStyles = useStyles;